module.exports = __webpack_public_path__ + "img/con2-img.d11774c6.png";